import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

// Adm
import EntityManagement from '@/Adm/EntityManagement/store'
import UserAuthorization from '@/Adm/UserAuthorization/store'

import CPD from '@/Adm/CPD/store'


// Osm
import GIPolicy from '@/Osm/GIPolicy/store'
import LifePolicy from '@/Osm/LifePolicy/store'
import ServiceRequest from '@/Osm/ServiceRequest/store'
import Provider from '@/Osm/Provider/store'
import Product from '@/Osm/Product/store'
import Renewal from '@/Osm/Renewal/store'
import Claim from '@/Osm/Claim/store'

// Home
import Homepage from '@/Homepage/store'

// Crm
import Crm from '@/Crm/store'

// My
import My from '@/My/store'

//Auth 
import Auth from '@/Auth/store'


//Adm
import Adm from '@/Adm/store'

//Dw
import Dw from '@/Dw/store'

// Validation
import Validation from '@/Validation/store'

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production'

export const store = new Vuex.Store({
  modules: {
    LifePolicy,
    GIPolicy,
    ServiceRequest,
    Provider,
    Product,
    Renewal,
    Claim,
    EntityManagement,
    Homepage,
    Crm,
    My,
    Auth,
    Adm,
    Dw,
    UserAuthorization,
    Validation,
    CPD
  },
  state: {
    role: '',
    permissionLevel: '',
    username:'',
  },
  strict: debug,
  actions,
  mutations,
  getters

})



// WEBPACK FOOTER //
// ./src/store/index.js